import { Chip } from "@mui/material";
import React from "react";
import "./chip.css";
import { t } from "i18next";

const ShinyChip = () => {
  return (
    <Chip
      label={t("package")}
      sx={{
        position: "absolute",
        zIndex: 999,
        right: 5,
        top: 5,
        background: "linear-gradient(45deg, #FF007F, #FF9E00)",
        color: "#ffffff",
        fontWeight: "bold",
        textTransform: "capitalize",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        borderRadius: "4px",
        padding: "0 8px",
        overflow: "hidden",
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: "-150%",
          width: "150%",
          height: "100%",
          background:
            "linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.8), transparent)",
          transform: "skewX(-45deg)",
          animation: "shinyEffect 2s infinite",
        },
      }}
    />
  );
};

export default ShinyChip;
